import React from "react";
import {
  CommonLabel,
  InputAndLabelWrapper,
  InputRowWrapper,
  SingleColumnWrapper,
} from "../../styles";
import CustomSelect from "../../inputs/CustomSelect";
import { useAddress } from "../../hooks";
import { useTranslation } from "react-i18next";
import TextInputWithLanguageControl from "../../inputs/TextInputWithLanguageControl";

function Address({
  countries = [],
  cities = [],
  transFormedCityOrVillage = [],
  namePrefix = "",
}) {
  const {
    handleVillageOrCityChange,
    handleGeorgianCityChange,
    handleCountryChange,
    showCityTextInput,
    isGeorgianCity,
    isGeorgia,
    isVillage,
  } = useAddress(namePrefix);

  const { t } = useTranslation();

  return (
    <>
      <SingleColumnWrapper>
        <InputAndLabelWrapper>
          <CommonLabel>{t("country")}</CommonLabel>
          <CustomSelect
            name={`${namePrefix}.country`}
            options={countries}
            rules={{ required: t("required") }}
            handleChange={handleCountryChange}
          />
        </InputAndLabelWrapper>

        {isGeorgia ? (
          <InputAndLabelWrapper>
            <CommonLabel>{t("cityVillage")}</CommonLabel>
            <CustomSelect
              name={`${namePrefix}.cityOrVillage`}
              options={transFormedCityOrVillage}
              rules={{ required: t("required") }}
              handleChange={handleVillageOrCityChange}
            />
          </InputAndLabelWrapper>
        ) : null}

        {isGeorgianCity ? (
          <InputAndLabelWrapper>
            <CommonLabel>{t("city_name")}</CommonLabel>
            <CustomSelect
              name={`${namePrefix}.georgianCity`}
              options={cities}
              rules={{ required: t("required") }}
              handleChange={handleGeorgianCityChange}
            />
          </InputAndLabelWrapper>
        ) : null}

        {showCityTextInput ? (
          <InputAndLabelWrapper>
            <TextInputWithLanguageControl
              name={`${namePrefix}.city`}
              label={t("city_name")}
              rules={{ required: t("required") }}
            />
          </InputAndLabelWrapper>
        ) : null}

        {isVillage ? (
          <InputAndLabelWrapper>
            <TextInputWithLanguageControl
              name={`${namePrefix}.village`}
              label={t("village_name")}
              rules={{ required: t("required") }}
            />
          </InputAndLabelWrapper>
        ) : null}
      </SingleColumnWrapper>

      <InputRowWrapper>
        <InputAndLabelWrapper>
          <TextInputWithLanguageControl
            name={`${namePrefix}.street`}
            label={t("address")}
            rules={{ required: t("required") }}
          />
        </InputAndLabelWrapper>
      </InputRowWrapper>
    </>
  );
}

export default Address;
